import { __rest } from "tslib";
import clsx from 'clsx';
import React, { forwardRef } from 'react';
import CrossIcon from '@cmpkit/icon/lib/glyph/cross';
import { Button } from './Button';
function _StateButton(_a, ref) {
    var { onClear, quite, ghost, children, variant, wrapperClassName, size, disabled, active } = _a, props = __rest(_a, ["onClear", "quite", "ghost", "children", "variant", "wrapperClassName", "size", "disabled", "active"]);
    const classes = clsx('state-btn-wrapper', wrapperClassName, size ? `state-btn-wrapper-${size}` : '', {
        active,
    });
    return (React.createElement("div", { className: classes },
        React.createElement(Button, Object.assign({ quite: quite, ghost: ghost, variant: variant, disabled: disabled, active: active, size: size, ref: ref }, props), children),
        active && (React.createElement(Button, { variant: variant, quite: quite, ghost: ghost, active: active, disabled: disabled, size: size, className: 'state-btn-clear', onClick: onClear, iconBefore: React.createElement(CrossIcon, { className: 'shrink-0' }) }))));
}
export const StateButton = forwardRef(_StateButton);
//# sourceMappingURL=StateButton.js.map